export const queryKeys = {
  CONTRACT: 'CONTRACT',
  DRAFT_EXCEL: "DRAFT_EXCEL"
};
